import { jsx } from 'react/jsx-runtime';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';

const DynamicWidgetCard = ({ children }) => {
    const { widgetRef } = useWidgetContext();
    return (jsx("div", Object.assign({ ref: widgetRef, className: 'dynamic-widget-card' }, { children: children })));
};

export { DynamicWidgetCard };
